// extracted by mini-css-extract-plugin
export default {"order-container":"X137v","orderContainer":"X137v","title":"cFyIM"};